import { AiOutlineInstagram } from "react-icons/ai";
import { AiOutlineFacebook } from "react-icons/ai";
import { AiOutlineDiscord } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";

const data = [
  {
    id: 1,
    link: "https://www.instagram.com/emmanueljoshua_ej/",
    icon: <AiOutlineInstagram />,
  },
  {
    id: 2,
    link: "https://www.facebook.com/joshua.eerapogu",
    icon: <AiOutlineFacebook />,
  },
  {
    id: 3,
    link: "https://discord.com/channels/@me",
    icon: <AiOutlineDiscord />,
  },
  { id: 4, link: "https://github.com/20R01A0470", icon: <AiFillGithub /> },
];
export default data;
